module.exports = __webpack_public_path__ + "static/media/home-options-3.5c644aaa.webp";